import React, { useCallback, useEffect, useState } from "react";
import {
  useGetContactDetailsQuery,
  useSubmitSubscribeMutation,
} from "../Store/api/CommonApi";
import { error, success } from "../Services/CommonService";
import { InstagramEmbed } from "react-social-media-embed";

export default function Footer() {
  const [contact, setContact] = useState({});
  const [submitSubscribe] = useSubmitSubscribeMutation();
  const contactApi = useGetContactDetailsQuery();
  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      const formData = new FormData(e.target);
      let data = Object.fromEntries(formData);
      submitSubscribe(data)
        .then((res) => {
          if (res.data?.code === "success") {
            e.target.reset();
            success(res.data?.message);
          } else {
            error("Request not submission failed.");
          }
        })
        .catch((err) => console.log(err));
    },
    [submitSubscribe]
  );

  useEffect(() => {
    if (contactApi?.data?.data) {
      setContact(contactApi?.data?.data);
    }
  }, [contactApi?.data, setContact]);

  return (
    <footer className="footer-area section-gap">
      <div className="container">
        <div className="row">
          <div className="col-lg-3  col-md-12">
            <div className="single-footer-widget">
              <h6>Useful Links</h6>
              <ul className="footer-nav">
                <li>
                  <a
                    href="https://www.thepridecircle.com/rise2025/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    RISE 2025
                  </a>
                </li>
                {/* <li>
                  <a
                    href="https://www.thepridecircle.com/tis"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Trans Inclusion Summit
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.workplaceequalityindex.in"
                    target="_blank"
                    rel="noreferrer"
                  >
                    India Workplace Equality Index
                  </a>
                </li> */}
                {/* <li>
                  <a
                    href="https://www.thepridecircle.com/ieei"
                    target="_blank"
                    rel="noreferrer"
                  >
                    India Education Equality Index
                  </a>
                </li> */}
                <li>
                  <a
                    href="https://www.thepridecircle.com/100qi"
                    target="_blank"
                    rel="noreferrer"
                  >
                    100 Queer Internship Program
                  </a>
                </li>
                {/* <li>
                  <a
                    href="https://www.linkedin.com/posts/pride-ed_last-call-for-registration-ycfp-2024-activity-7217159677707501568-ErG-/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Youth Changemakers Fellowship Program
                  </a>
                </li> */}
                <li>
                  <a
                    href="https://shop.thepridecircle.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Rainbow Bazaar
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-6  col-md-12">
            <div className="single-footer-widget newsletter">
              <h6>Stay Connected – Empower Your Career</h6>
              <p style={{ fontSize: "13px" }}>
                Sign up to receive exclusive updates on events, workshops, and job opportunities designed for <b>women and LGBT+ candidates</b>.
              </p>
              <p style={{ fontSize: "13px" }}>Discover new ways to grow, learn, and build your career with Pride Circle.</p>
              <div id="mc_embed_signup">
                <form onSubmit={handleSubmit}>
                  <div className="form-group row" style={{ width: "100%" }}>
                    <div className="col-lg-8 col-md-12">
                      <input
                        name="email"
                        placeholder="Enter Email"
                        //onfocus="this.placeholder = ''"
                        //onblur="this.placeholder = 'Enter Email '"
                        required
                        type="email"
                      />
                    </div>
                    <div className="col-lg-4 col-md-12">
                      <button type="submit" className="nw-btn primary-btn">
                        Subscribe
                        <span className="lnr lnr-arrow-right" />
                      </button>
                    </div>
                  </div>
                  <div className="info" />
                </form>
              </div>
            </div>
          </div>
          <div className="col-lg-3  col-md-12">
            <div className="single-footer-widget mail-chimp">
              <h6 className="mb-20">Instragram Feed</h6>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <InstagramEmbed url="https://www.instagram.com/pride_circle/" />
              </div>
              {/*<ul className="instafeed d-flex flex-wrap">
                <li>
                  <img src="img/i1.jpg" alt="" />
                </li>
                <li>
                  <img src="img/i2.jpg" alt="" />
                </li>
                <li>
                  <img src="img/i3.jpg" alt="" />
                </li>
                <li>
                  <img src="img/i4.jpg" alt="" />
                </li>
                <li>
                  <img src="img/i5.jpg" alt="" />
                </li>
                <li>
                  <img src="img/i6.jpg" alt="" />
                </li>
                <li>
                  <img src="img/i7.jpg" alt="" />
                </li>
                <li>
                  <img src="img/i8.jpg" alt="" />
                </li>
              </ul>*/}
            </div>
          </div>
        </div>
        <div className="row footer-bottom d-flex justify-content-between">
          <p className="col-lg-8 col-sm-12 footer-text m-0 text-white">
            {/* Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. */}
            Copyright © All rights reserved | This website is made with&nbsp;
            <i className="fa fa-heart-o" aria-hidden="true" /> by &nbsp;
            <a
              href={contact?.website_url ?? "https://www.thepridecircle.com/"}
              target="_blank"
              rel="noreferrer"
            >
              Pride Circle
            </a>
          </p>
          <div className="col-lg-4 col-sm-12 footer-social">
            {contact?.facebook_link !== "" && (
              <a
                href={
                  contact?.facebook_link ??
                  "https://www.facebook.com/PrideCircles/"
                }
              >
                <i className="fa fa-facebook" />
              </a>
            )}
            {contact?.instragram_link !== "" && (
              <a
                href={
                  contact?.instragram_link ??
                  "https://www.instagram.com/pride_circle/?hl=en"
                }
              >
                <i className="fa fa-instagram" />
              </a>
            )}
            {contact?.youtube_link !== "" && (
              <a
                href={
                  contact?.youtube_link ??
                  "https://www.youtube.com/channel/UCoaAZWnpjFXcCQ5Und9mi0Q"
                }
              >
                <i className="fa fa-youtube" />
              </a>
            )}
            {contact?.linkedin_link !== "" && (
              <a
                href={contact?.linkedin_link ?? "https://linktr.ee/pridecircle"}
              >
                <i className="fa fa-linkedin" />
              </a>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
}
